import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function elevation(_ref, theme) {
  var _elevation = _ref.elevation,
      styles = _objectWithoutPropertiesLoose(_ref, ["elevation"]);

  if (typeof _elevation !== 'undefined') {
    styles.boxShadow = theme.elevations[parseFloat(_elevation) - 1];
  }

  return styles;
}

export default elevation;